/**
 * Extracts the first name from a full name string.
 * Returns a fallback value if the name is empty or invalid.
 */
export function getFirstName(name: string | undefined | null, fallback = 'the expert'): string {
  if (!name || typeof name !== 'string' || !name.trim()) {
    return fallback;
  }
  return name.trim().split(' ')[0];
}
